import "./FileDrop.scss";
export * from "react-file-drop";
